import React, { useState } from 'react';
import DashboardLayout from '@/components/layout/DashboardLayout';
import PageTransition from '@/components/ui/page-transition';
import { PolicyExecutorSimulation } from '@/components/policies/simulation/PolicyExecutorSimulation';
import { useSearchParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useIsMobile } from '@/hooks/use-mobile';
import { cn } from '@/lib/utils';
import { policies } from '@/components/policies/PolicyData';
import { 
  Select, 
  SelectContent, 
  SelectItem, 
  SelectTrigger, 
  SelectValue 
} from '@/components/ui/select';

const PolicyAutoExecutor = () => {
  const [searchParams] = useSearchParams();
  const policyId = searchParams.get('id');
  const teamId = searchParams.get('teamId');
  const teamName = searchParams.get('teamName');
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  
  const [selectedPolicyId, setSelectedPolicyId] = useState<number>(
    policyId ? parseInt(policyId) : (policies.length > 0 ? policies[0].id : 1)
  );
  
  const handleGoBack = () => {
    navigate('/teams');
  };
  
  const handlePolicyChange = (value: string) => {
    setSelectedPolicyId(parseInt(value));
  };
  
  return (
    <DashboardLayout>
      <PageTransition>
        <div className={cn(
          "mb-6 flex items-center",
          isMobile ? "flex-col items-start space-y-3" : "justify-between"
        )}>
          <div className="flex items-center">
            <Button 
              variant="ghost" 
              size="icon" 
              onClick={handleGoBack} 
              className="mr-3 h-8 w-8"
            >
              <ArrowLeft className="h-4 w-4" />
            </Button>
            
            <div>
              <h1 className="text-xl md:text-2xl font-bold">Policy Auto Executor</h1>
              {teamName && (
                <p className="text-sm text-muted-foreground">
                  Running on team: {teamName}
                </p>
              )}
            </div>
          </div>
          
          <div className="min-w-[240px]">
            <Select 
              value={selectedPolicyId.toString()} 
              onValueChange={handlePolicyChange}
            >
              <SelectTrigger className="w-full">
                <SelectValue placeholder="Select a policy" />
              </SelectTrigger>
              <SelectContent>
                {policies.map((policy) => (
                  <SelectItem key={policy.id} value={policy.id.toString()}>
                    {policy.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
        
        <div className={cn("h-[calc(100vh-8rem)] w-full")}>
          <PolicyExecutorSimulation 
            policyId={selectedPolicyId} 
            teamId={teamId || undefined} 
            teamName={teamName || undefined}
          />
        </div>
      </PageTransition>
    </DashboardLayout>
  );
};

export default PolicyAutoExecutor;
